import { FaStar, FaRegStar } from 'react-icons/fa';
import { formatPhone } from '../../../utlis';
import MyTable from '../../../components/MyTable';
import FilterPopup from '../../../components/FilterPopup';

// Render star rating
const renderStarRating = (rating) => {
  const maxStars = 5;
  const ratingValue = parseInt(rating, 10) || 0;
  const stars = [];

  for (let i = 1; i <= maxStars; i++) {
    stars.push(
      i <= ratingValue ? (
        <FaStar key={i} className="text-yellow-400" size={14} />
      ) : (
        <FaRegStar key={i} className="text-gray-300" size={14} />
      )
    );
  }

  return <div className="flex gap-0.5">{stars}</div>;
};

const CandidateTable = ({
  data,
  isLoading,
  onEditCandidate,
  pageSize,
  onPageSizeChange,
  isFilterPopupOpen,
  onFilterClick,
  onCloseFilterPopup,
  onApplyFilters,
  getSearchResults,
  filterCategories,
  tableData,
}) => {
  // Transform data to ensure consistent field names
  const transformedData = data.map((candidate) => ({
    candidate_id: candidate.candidate_id || '',
    candidateInfo: {
      name: `${candidate.first_name || ''} ${candidate.middle_name || ''} ${candidate.last_name || ''}`.trim(),
      email: candidate.email_id || '',
      phone: candidate.phone || candidate.mobile || '',
      rating: candidate.rating || 0,
    },
    technology: candidate.division || '',
    jobTitle: candidate.job_title || '',
    workStatus: candidate.legal_status || '',
    salesPerson: candidate.sales_person_name || '',
    interviews: candidate.total_interviews || '',
    marketing: candidate.marketing_group_id || '',
    status: candidate.status || '',
  }));

  const columns = [
    {
      name: 'candidate_id',
      label: 'ID',
      options: {
        display: false,
      },
    },
    {
      name: 'candidateInfo',
      label: 'Candidate Info',
      options: {
        filter: false,
        sort: true,
        customBodyRender: (value, tableMeta) => {
          const candidateId = tableMeta.rowData[0];
          const candidate = data.find((c) => c.candidate_id === candidateId);
          return (
            <div className="flex flex-col">
              <h3
                onClick={() => onEditCandidate(candidate)}
                className="text-base font-bold text-auxiliary-800 cursor-pointer hover:underline"
              >
                {value.name || 'N/A'}
              </h3>
              {value.phone && (
                <p className="text-text-hint text-sm block">{formatPhone(value.phone)}</p>
              )}
              <p className="text-text-hint text-sm block">{value.email || ''}</p>
              <div className="mt-1 block">
                {renderStarRating(value.rating)}
              </div>
            </div>
          );
        },
      },
    },
    {
      name: 'technology',
      label: 'Technology',
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value) => (
          <p className="text-text-hint">{value || 'N/A'}</p>
        ),
      },
    },
    {
      name: 'jobTitle',
      label: 'Job Title',
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value) => (
          <p className="text-text-hint break-all">{value || 'N/A'}</p>
        ),
      },
    },
    {
      name: 'workStatus',
      label: 'Work Status',
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value) => (
          <p className="text-text-hint">{value || 'N/A'}</p>
        ),
      },
    },
    {
      name: 'salesPerson',
      label: 'Sales Person',
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value) => (
          <p className="text-center text-text-hint">{value || 'N/A'}</p>
        ),
      },
    },
    {
      name: 'interviews',
      label: 'Interviews',
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value) => (
          <p className="text-text-default font-bold">{value || '-'}</p>
        ),
      },
    },
    {
      name: 'marketing',
      label: 'Marketing',
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value) => (
          <p className="text-text-hint">{value || '-'}</p>
        ),
      },
    },
    {
      name: 'status',
      label: 'Status',
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value) => (
          <p className="text-text-default font-bold">{value || 'N/A'}</p>
        ),
      },
    },
  ];

  const options = {
    filterType: 'dropdown',
    responsive: 'standard',
    rowsPerPage: pageSize,
    rowsPerPageOptions: [5, 10, 15, 20, 50],
    onChangeRowsPerPage: (numberOfRows) => onPageSizeChange(numberOfRows),
    selectableRows: 'none',
    elevation: 0,
    filter: true,
    search: false,
    download: true,
    print: true,
    viewColumns: true,
    textLabels: {
      body: {
        noMatch: !isLoading && (!data || data.length === 0) ? 'Sorry, no matching found' : '',
      },
    },
  };

  return (
    <div className="w-full overflow-x">
      <MyTable
        title=""
        data={isLoading ? [] : transformedData}
        columns={columns}
        options={options}
        onFilterClick={onFilterClick}
      />
      {isFilterPopupOpen && (
        <FilterPopup
          onClose={onCloseFilterPopup}
          onApply={onApplyFilters}
          tableData={tableData}
          categories={filterCategories}
          getSearchResults={getSearchResults}
        />
      )}
    </div>
  );
};

export default CandidateTable;
